import {ME_TYPE} from './actions';
import {InitialState} from "./state";

export function reducer(state = InitialState, action) {
    if (action.type === ME_TYPE) {
        return action.reduce(state);
    } else {
        return state;
    }
}
